import styled from 'styled-components';

export const BreadCrumbWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
